'use strict';

define('modules/module.static',[
  './module',
  'txt!./module.static.hbs',
  'lib/imgix'
], function (
  Module,
  txtTemplate,
  imgix
) {
  var StaticModule = Module.extend({
    template: Handlebars.compile(txtTemplate),

    formatTemplateContext: function (context, layout) {
      var newCtx = context;
      if (newCtx.image && layout === '1x1') {
        newCtx.image['1x1'] = imgix(newCtx.image['1x1'], { w: 310 });
      }

      if (newCtx.image && layout === '2x1') {
        newCtx.image['2x1'] = imgix(newCtx.image['2x1'], { w: 393 });
      }

      if (newCtx.image && layout === '3x1') {
        newCtx.image['3x1'] = imgix(newCtx.image['3x1'], { w: 636 });
      }
      // TODO: surely this can be better. Plus, do for 'fullx1'

      var ctx = Module.prototype.formatTemplateContext.call(this, newCtx, layout);

      if (layout === 'fullx1') {
        // We need to add the module body placement class
        ctx.moduleClassName = (ctx.moduleClassName || '') + ' module-placement-' + (ctx.placement || 'left');
      }

      return ctx;
    }
  });


  return StaticModule;
});

